import {Component, Input, ViewChild} from '@angular/core';
import {TableComponent} from "../../../../shared/components/table/table.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../../core/services/general.service";
import {NewEventComponent} from "../new-event/new-event.component";
import {AddEvidenceComponent} from "../add-evidence/add-evidence.component";
import {CancelEventComponent} from "../cancel-event/cancel-event.component";
import {CanceledEventListComponent} from "../canceled-event-list/canceled-event-list.component";
import {EventsEvidenceFilesComponent} from "../events-evidence-files/events-evidence-files.component";
import {NgIf} from "@angular/common";
import {TableModalComponent} from "../../../../shared/components/table/table-modal.component";

@Component({
  selector: 'app-events-table',
  standalone: true,
  imports: [
    TableComponent,
    TableModalComponent,
    NgIf
  ],
  templateUrl: './events-table.component.html',
  styleUrl: './events-table.component.scss'
})
export class EventsTableComponent {
  //Variables por modal
  @Input() data: any = null;
  @Input() close!: (data: any) => void;
  //Variables del modulo
  configurationTable: any = {
    "columns": [
      {
        "id": "service_events.id",
        "title": "Evento",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "service_events.service_id",
        "title": "Orden de Servicio",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "listService",
          "idColumn": "id",
          "valueColumn": "ruta"
        },
        "required": true,
      },
      {
        "id": "service_events.event_date",
        "title": "Fecha",
        "type": "date",
        "placeholder": "",
        "required": false,
      },
      {
        "id": "typeService.configurableListsCode",
        "title": "Tipo Evento",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "listConfigurableEvent",
          "idColumn": "idconfigurableLists",
          "valueColumn": "configurableListsCode",
          "conditionColumn":"configurableListsField",
          "conditionValue":"Motivo del evento"
        },
        "required": true,
      },
      {
        "id": "reason.configurableListsCode",
        "title": "Motivo",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "listConfigurableEvent",
          "idColumn": "idconfigurableLists",
          "valueColumn": "configurableListsCode",
          "conditionColumn":"configurableListsField",
          "conditionValue":"Tipo Evento"
        },
        "required": true,
      },
      {
        "id": "service_events.event_description",
        "title": "Descripción",
        "type": "text",
        "placeholder": "",
        "required": false,
      },
      {
        "id": "service_events.amount",
        "title": "Monto",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": false
      },
      {
        "id": "service_events.assigned",
        "title": "Asignado a",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "asignedTo",
        },
        "required": false,
      },
      {
        "id": "service_events.deductible",
        "title": "Deducible",
        "type": "select",
        "placeholder": "",
        "serviceConfig": {
          "table": "deductible",
        },
        "required": false,
      },
      {
        "id": "event_evidences.evidence_status",
        "title": "Evidencias",
        "type": "link",
        "placeholder": "",
        "required": false,
        "hide": true,
        "action": {
          "type": "emmit",
          "fn": this.getEvidenceFiles.bind(this)
        },
      },
      {
        "id": "service_events.relatedEventId",
        "title": "Evento relacionado",
        "onlyTable": true
      },
      {
        "btnName": "Opciones",
        "actions": [
          {
            "btnName": "Agregar relacionado",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.addRelatedEvent.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-primary border border-primary',
              "icons": 'plus'
            }
          },
          {
            "btnName": "Editar evento",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.editEvent.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-success border border-success',
              "icons": 'edit'
            }
          },
          {
            "btnName": "Cancelar evento",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.cancelEvent.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-danger border border-danger',
              "icons": 'trash-2'
            }
          },
        ]
      }
    ],
    "config": "serviceEvents",
    "sortColumn": "service_events.event_date",
    "sortDirection": "ASC",
    "title": "Evento",
    "modalAdd":"NewEventComponent",
    "header":{
      "extraFn":true,
      "actions":[
        {
          "type":"button",
          "class":"btn btn-outline-info",
          "label":"Eventos cancelados"
        }
      ]
    },
    "filterPrincipal": [
    ],
    "filters":[]
  };
  @ViewChild(TableComponent) tableComponent!: TableComponent;
  @ViewChild(TableModalComponent) tableModuleComponent!: TableModalComponent;
  constructor(public modalEvent : NgbModal, private generalService:GeneralService) {}

  newEvent(row:any){
    let modal = this.modalEvent.open(NewEventComponent, { centered: true, size:'xl' });
    modal.componentInstance.data = row;
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDO
    };
  }


  addEvidence(row:any){
    let modal = this.modalEvent.open(AddEvidenceComponent, { centered: true });
    modal.componentInstance.data = row;
    modal.componentInstance.typeAction = 'add';
    modal.componentInstance.confirmAction = (data: any) => {
      if (this.tableComponent) {
        this.tableComponent.reloadTable();
      } else {
        this.generalService.showMessage('warn', 'Error! No fue posible recargar el tablero.');
      }
      modal.close();
    };

  }
  editEvent(row:any){
    let modal = this.modalEvent.open(NewEventComponent, { centered: true, size:'xl' });
    modal.componentInstance.data = row;
    modal.componentInstance.typeAction = 'edit';
    modal.componentInstance.confirmAction = (data: any) => {
      if (this.tableComponent) {
        this.tableComponent.reloadTable();
      } else {
        this.generalService.showMessage('warn', 'Error! No fue posible recargar el tablero.');
      }
      modal.close();
    };
  };

  addRelatedEvent(row:any){
    let modal = this.modalEvent.open(NewEventComponent, { centered: true, size:'xl' });
    modal.componentInstance.data = row;
    modal.componentInstance.typeAction = 'related';
    modal.componentInstance.confirmAction = (data: any) => {
      if (this.tableComponent) {
        this.tableComponent.reloadTable();
      } else {
        this.generalService.showMessage('warn', 'Error! No fue posible recargar el tablero.');
      }
      modal.close();
    };
  };

  cancelEvent(row:any){
    let modal = this.modalEvent.open(CancelEventComponent, { centered: true, size:'md' });
    modal.componentInstance.data = row;
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDo;
    };
  }

  /**
   * Function: Abrir modal para visualizar los archivos de evidencia
   */
  getEvidenceFiles(row: any){
    if(row.evidence_urls && row.evidence_urls.split(',').length > 0) {
      let modal = this.modalEvent.open(EventsEvidenceFilesComponent, { centered: true, size:'xl' });
      modal.componentInstance.list = row.evidence_urls;
      modal.componentInstance.close = () => {
        modal.close();
      }
    } else {
      this.generalService.showMessage('warn', 'No hay evidencias disponibles para mostrar.');
    }
  }

  //Función para aplicar el filtro general de la modal
  applyFilterModal() {
    this.configurationTable.filterPrincipal = [
      {
        "column": "service_events.service_id",
        "operator": "=",
        "value": this.data['service.id']
      }
    ];
    return this.configurationTable;
  }
}
